import React from 'react';

import { Skeleton } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './CourseLoaderSkeleton.scss';

export function CourseLoaderSkeleton(): JSX.Element {
	useStyles(s);
	const innerHeight = window.innerHeight - 80;
	const itemCount = Math.trunc(innerHeight / (72 + 40));

	return (
		<div
			sl-test-data="cmpCourseLoaderSkeleton"
			className="loading-course-skeleton-item-wrapper"
		>
			{[...Array(itemCount)].map((item, index) => (
				<div key={index} className="loading-course-skeleton-item">
					<Skeleton.Avatar
						size={40}
						className="loading-course-skeleton-item__avatar"
					/>
					<div className="loading-course-skeleton-item__texts">
						<Skeleton.Text
							size={40}
							className="loading-course-skeleton-item__first-text"
						/>
						<Skeleton.Text
							size={40}
							className="loading-course-skeleton-item__second-text"
						/>
						<Skeleton.Text
							size={40}
							className="loading-course-skeleton-item__third-text"
						/>
					</div>
				</div>
			))}
		</div>
	);
}
